<template>
  <div class="warp" style="padding: 0 20px; height: calc(100vh - 80px); overflow: auto">
    <div style="margin-bottom: 10px">
      <el-button
        size="small" type="primary" @click="exportToExcel"
      >{{ $t('newOrder.export') }}
      </el-button>
    </div>
    <!--  表格数据  -->
    <el-table
      :data="tableData"
      :header-cell-style="{ background: '#f2f2f2', color: 'black' }"
      border
      style="width: 100%"
    >
      <el-table-column
        :label="$t('GlobalSetObj.serial')" align="center" type="index"
        width="80"
      />
      <el-table-column
        v-for="item in tableHeaderList"
        :key="item.id"
        :label="item.label"
        :min-width="item.cloWidth"
        :prop="item.prop"
      >
        <template slot-scope="scope">
          <div>{{ scope.row[item.prop] ? `${scope.row[item.prop]}` : '--' }}</div>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <el-pagination
        :current-page.sync="searchForm.pageNumber"
        :page-size.sync="searchForm.pageSize"
        :page-sizes="[10, 20, 50, 100]"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        style="margin: 15px 0"
        @current-change="getSearch"
        @size-change="getSearch"
      />
    </div>
  </div>
</template>

<script>
import { returnDataMonitoringdetail, returnDataMonitoringdetailexport } from '@/api/orderApi';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  props: {
    dataobj: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      searchForm: {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillNumber: ''
        }
      },
      tableData: [],
      total: 0,
      tableHeaderList: [
        {
          id: 1,
          label: this.$t('GlobalSetObj.waybillNumber'),
          prop: 'waybillNumber',
          cloWidth: 180
        },
        {
          id: 2,
          label: this.$t('GlobalSetObj.ScanNumber'),
          prop: 'scanOrderNumber',
          cloWidth: 180
        },
        { id: 3, label: this.$t('newOrder.waybillStatus'), prop: 'waybillStatus', cloWidth: 180 },
        // { id: 5, label: this.$t('newOrder.LatestTime'), prop: 'waybillStatusName', cloWidth: 180 },
        {
          id: 6,
          label: this.$t('orderCenterCont.zuixinguijineir'),
          prop: 'latestTrackContent',
          cloWidth: 180
        },
        { id: 4, label: this.$t('GlobalSetObj.ReturnTime'), prop: 'returnTime', cloWidth: 180 },
        {
          id: 7,
          label: this.$t('customerManagements.returnedShipmentsTime'),
          prop: 'returnedShipmentsTime',
          cloWidth: 180
        }
      ]
    };
  },
  created() {
    this.getSearch();
  },
  methods: {
    getSearch() {
      const data = {
        pageNumber: this.searchForm.pageNumber,
        pageSize: this.searchForm.pageSize,
        params: {
          operationTime: this.dataobj.operationTime,
          siteId: this.dataobj.siteId,
          isTest: this.dataobj.isTest,
          operationUserId: this.dataobj.operationUserId,
          type: this.dataobj.type
        }
      };
      returnDataMonitoringdetail(data).then((res) => {
        console.log(res);
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.total = res.data.total;
        }
      });
    },
    async exportToExcel() {
      const data = {
        operationTime: this.dataobj.operationTime,
        siteId: this.dataobj.siteId,
        isTest: this.dataobj.isTest,
        operationUserId: this.dataobj.operationUserId,
        type: this.dataobj.type
      };
      const res = await returnDataMonitoringdetailexport(data);
      if (res.code === 200) {
        const toRes = await goResourceTaskList();
        if (toRes) {
          this.$emit('call-parent-method', false);
        }
      }
    },
    resetForm() {
      this.searchForm = {
        pageNumber: 1,
        pageSize: 10,
        params: {
          waybillNumber: ''
        }
      };
      this.getSearch();
    }
  }
};
</script>

<style scoped>
.search-form {
  margin-bottom: 20px;
}

.warp >>> .el-form-item {
  margin-bottom: 0 !important;
}
</style>
